import apiClient from "../api/apiClient"

export interface DashboardStats {
  currentMonth: {
    totalExecutedCtns: number
    totalSalesValue: number
    period: {
      month: number
      year: number
      monthName: string
    }
  }
  systemTotals: {
    totalCustomers: number
    totalOutstandingBalance: number
  }
}

export const dashboardService = {
  // Get dashboard statistics
  async getDashboardStats(): Promise<DashboardStats> {
    const response = await apiClient.get<DashboardStats>("/admin/dashboard/stats")
    return response.data
  },
}


